// @flow

import * as React from 'react';
import PropTypes from 'prop-types';

import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import Input from '@mui/material/Input';
// import Tooltip from '@mui/material/Tooltip';

type DataTable$column = {
  id: string,
  align: 'left' | 'right',
  padding: 'normal' | 'checkbox' | 'none',
  disablePadding: boolean,
  label: string,
  filter: boolean | mixed
};

type Props = {
  expandable: boolean,
  filters: { [string]: string | number | boolean },
  columnData: Array<DataTable$column>,
  onRequestSort: (mixed, string) => void,
  onSelectAllClick?: (mixed) => void,
  order: 'asc' | 'desc',
  orderBy: string,
  numSelected: number,
  rowCount: number
};

class EnhancedTableHead extends React.Component<Props> {
  createSortHandler = (property: string) => (event: mixed) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {
      filters,
      columnData,
      onSelectAllClick,
      expandable,
      order,
      orderBy,
      numSelected,
      rowCount
    } = this.props;

    const isFilteringEnabled = columnData.filter((column) => column.filter)
      .length;

    return (
      <TableHead>
        <TableRow>
          {onSelectAllClick && (
            <TableCell padding="checkbox">
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={numSelected === rowCount}
                onChange={onSelectAllClick}
              />
            </TableCell>
          )}
          {expandable && <TableCell padding="checkbox" />}
          {columnData.map((column) => {
            return (
              <TableCell
                key={column.id}
                align={column.align}
                padding={
                  column.disablePadding ? 'none' : column.padding || 'normal'
                }
                sortDirection={orderBy === column.id ? order : false}
                style={{ whiteSpace: 'nowrap' }}
              >
                <TableSortLabel
                  active={orderBy === column.id}
                  direction={order}
                  onClick={this.createSortHandler(column.id)}
                >
                  {column.label}
                </TableSortLabel>
              </TableCell>
            );
          }, this)}
        </TableRow>
        {isFilteringEnabled ? (
          <TableRow>
            {onSelectAllClick && <TableCell padding="checkbox" />}
            {expandable && <TableCell padding="checkbox" />}
            {columnData.map((column) => {
              const padding = column.disablePadding
                ? 'none'
                : column.padding || 'normal';

              if (!column.filter) {
                return <TableCell key={column.id} padding={padding} />;
              }

              const filter = filters[column.id];

              if (column.filter === true) {
                return (
                  <TableCell key={column.id} padding={padding}>
                    {column.checkbox ? (
                      <Checkbox
                        color="primary"
                        checked={filter || false}
                        name={column.id}
                        onChange={this.props.onRequestFilter}
                      />
                    ) : (
                      <Input
                        name={column.id}
                        value={filter || ''}
                        onChange={this.props.onRequestFilter}
                        placeholder={this.props.i18n('Filter...')}
                      />
                    )}
                  </TableCell>
                );
              }

              const FilterCell = column.filter;
              return (
                <FilterCell
                  key={column.id}
                  column={column}
                  padding={padding}
                  name={column.id}
                  value={filter}
                  onChange={this.props.onRequestFilter}
                  i18n={this.props.i18n}
                />
              );
            }, this)}
          </TableRow>
        ) : null}
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestFilter: PropTypes.func.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
};

export default EnhancedTableHead;